/**
 * h5端路由
 */

import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
Vue.use(VueRouter);

const createMobileRouter = async () => {
  const conversation = await import("./pages/conversation");
  const login = await import("./pages/login");
  const beforePage = await import("./pages/before-page");
  const upLoadImg = await import("./pages/upLoadImg");
  const customerMessage = await import("./pages/customerMessage");

  const isProduction = process.env.NODE_ENV === "production";

  console.log(process.env.NODE_ENV);

  const decode = await import("./pages/decode");

  const routes = [
    {
      path: "/",
      redirect: "/before-page"
    },
    {
      path: "/login",
      name: "login",
      component: login.default
    },
    {
      path: "/conversation",
      name: "conversation",
      component: conversation.default
    },
    {
      path: "/before-page",
      name: "before-page",
      component: beforePage.default
    },
    {
      path: "/upLoadImg",
      name: "upLoadImg",
      component: upLoadImg.default
    },
    {
      path: "/customerMessage",
      name: "customerMessage",
      component: customerMessage.default
    }
  ];

  if (!isProduction) {
    routes.push({
      path: "/decode",
      name: "decode",
      component: decode.default
    });
  }

  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
  });
  router.beforeEach((to, from, next) => {
    store.commit("setState", { isload: true });
    next();
  });
  router.afterEach(() => {
    store.commit("setState", { isload: false });
    // setTimeout(() => {
    //   store.commit("setState", { isload: false });
    // }, 1000);
  });
  const routerPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error);
  };
  return router;
};

export default createMobileRouter;
